import React from "react";
import { Field } from "redux-form";
import { CheckboxField } from "cxa-form-field";
import { renderField, RadioButtonGroupRow } from "./components";
import { validateRequired } from "./validation";

export const formContent = renderValue => (
  <div style={{ padding: "10px 20px 10px 10px" }}>
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td style={{ width: 400 }}>
            <div
              style={{
                border: "2px solid #000",
                paddingLeft: 10,
                fontSize: 16,
                fontWeight: "bold",
              }}
            >
              GROUP INSURANCE
              <br />
              PERSONAL HEALTH DECLARATION FORM
            </div>
            <br />
            <div style={{ border: "1px solid #000", width: 300 }}>
              <table>
                <tbody>
                  <tr>
                    <td style={{ paddingLeft: 10, paddingRight: 20 }}>Policy No.</td>
                    <td>
                      <table style={{ borderCollapse: "collapse" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingLeft: 10, paddingRight: 20 }}>Date Sent</td>
                    <td>
                      <table style={{ borderCollapse: "collapse" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td style={{ textAlign: "right" }}>
            <img
              src="/assets/images/hdf/ge-logo.png"
              alt=""
            />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      style={{
        color: "#f00",
        fontWeight: "bold",
        fontSize: "10pt",
        padding: 10,
        borderTop: "2px solid #000",
        borderBottom: "2px solid #000",
      }}
    >
      Important Note: Pursuant to Section 25(5) of the Insurance Act (Cap. 142), you are to disclose
      in this form, fully and faithfully, all the facts <br />
      which you know or ought to know, otherwise, nothing may be payable under the Policy.
    </div>
    <div>
      <table>
        <tbody>
          <tr>
            <td
              style={{
                color: "#f00",
                fontSize: "10pt",
                padding: 10,
                fontWeight: "bold",
                width: 60,
              }}
            >
              NOTE:
            </td>
            <td style={{ color: "#f00", fontSize: "10pt", padding: 10 }}>
              <ol style={{ paddingLeft: 0 }}>
                <li>
                  All questions must be answered in ink. Dashes, strokes, ditto and N.A. are not
                  acceptable.
                </li>
                <li>Any alteration to the answers must be signed in full.</li>
                <li style={{ fontWeight: "bold" }}>
                  All pages must be signed by the Employee/Eligible Member.
                </li>
              </ol>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style={{ fontWeight: "bold", paddingBottom: 10 }}>
      {'The "Company" shall mean The Great Eastern Life Assurance Company Limited.'}
    </div>
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td style={{ fontWeight: "bold", width: 260 }}>NAME OF POLICYHOLDER (EMPLOYER)</td>
          <td style={{ borderBottom: "1px solid #000" }}>&nbsp;</td>
        </tr>
      </tbody>
    </table>
    <div
      style={{
        color: "#f00",
        fontWeight: "bold",
        fontSize: "10pt",
        borderBottom: "2px solid #000",
        paddingBottom: 5,
      }}
    />
    <div style={{ paddingBottom: 5 }} />
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            I)&nbsp;&nbsp;PARTICULARS of the EMPLOYEE/ELIGIBLE MEMBER
          </td>
        </tr>
        <tr>
          <td style={{ paddingBottom: 5, border: "1px solid #000" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ paddingLeft: 10, width: 20 }}>a.</td>
                  <td>Name (According to NRIC/Passport)</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td style={{ borderBottom: "1px solid #000" }} id="RO_EmployeeName">
                    {renderValue({
                      fieldName: "EmployeeName",
                      fieldFormat: "text",
                    })}
                    <Field component={renderField} type="hidden" name="EmployeeName" />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #000" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      width: "50%",
                      borderRight: "1px solid #000",
                      paddingBottom: 5,
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ paddingLeft: 10, width: 20 }}>b.</td>
                          <td>
                            NRIC/Passport
                            <sup>*</sup> Number
                          </td>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td style={{ borderBottom: "1px solid #000" }} id="RO_Identification">
                            {renderValue({
                              fieldName: "Identification",
                              fieldFormat: "text",
                            })}
                            <Field component={renderField} type="hidden" name="Identification" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              paddingLeft: 10,
                              width: 20,
                              paddingBottom: 5,
                            }}
                          >
                            c.
                          </td>
                          <td>Nationality</td>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td style={{ paddingBottom: 5 }}>
                            <Field
                              component={renderField}
                              type="text"
                              name="Nationality"
                              style={{ width: 200 }}
                              validate={validateRequired}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ paddingBottom: 5, border: "1px solid #000" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ paddingLeft: 10, width: 20 }}>d.</td>
                  <td>Occupation</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 500 }}
                      name="JobTitle"
                      validate={validateRequired}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #000" }}>
            <table style={{ borderCollapse: "collapse", width: "initial" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      width: "25%",
                      borderRight: "1px solid #000",
                      paddingBottom: 5,
                      paddingRight: 20,
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ paddingLeft: 10, width: 20 }}>e.</td>
                        </tr>
                        <tr>
                          <td style={{ paddingLeft: 10, paddingBottom: 5 }}>
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td>Male</td>
                                  <td>
                                    <Field component={renderField} type="hidden" name="Gender" />
                                    <Field
                                      component={renderField}
                                      type="radio"
                                      name="Gender"
                                      id="RO_GenderMale"
                                      value="Male"
                                      disabled="disabled"
                                    />
                                  </td>
                                  <td style={{ width: 30 }} />
                                  <td>Female</td>
                                  <td>
                                    <Field
                                      component={renderField}
                                      type="radio"
                                      name="Gender"
                                      id="RO_GenderFemale"
                                      value="Female"
                                      disabled="disabled"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Single</td>
                                  <td>
                                    <Field
                                      component={renderField}
                                      type="hidden"
                                      name="MaritalStatus"
                                      id="MaritalStatus"
                                    />
                                    <Field
                                      component={renderField}
                                      type="radio"
                                      name="MaritalStatus"
                                      id="RO_MaritalStatusSingle"
                                      value="Single"
                                      disabled="disabled"
                                    />
                                  </td>
                                  <td style={{ width: 30 }} />
                                  <td>Married</td>
                                  <td>
                                    <Field
                                      component={renderField}
                                      type="radio"
                                      name="MaritalStatus"
                                      id="RO_MaritalStatusMarried"
                                      value="Married"
                                      disabled="disabled"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    style={{
                      width: "25%",
                      borderRight: "1px solid #000",
                      paddingBottom: 5,
                      paddingRight: 20,
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ paddingLeft: 10, width: 20 }}>f.</td>
                          <td>Date of Birth</td>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td style={{ paddingBottom: 5 }}>
                            <table
                              style={{
                                width: "100%",
                                border: "1px solid #000",
                                borderCollapse: "collapse",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                  >
                                    Day
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                  >
                                    Month
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                  >
                                    Year
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                    id="RO_BirthDateDay"
                                  >
                                    {renderValue({
                                      fieldName: "BirthDate",
                                      fieldFormat: "date",
                                      dateFormat: "DD",
                                    })}
                                    <Field component={renderField} type="hidden" name="BirthDate" />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                    id="RO_BirthDateMonth"
                                  >
                                    {renderValue({
                                      fieldName: "BirthDate",
                                      fieldFormat: "date",
                                      dateFormat: "MMM",
                                    })}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                    id="RO_BirthDateYear"
                                  >
                                    {renderValue({
                                      fieldName: "BirthDate",
                                      fieldFormat: "date",
                                      dateFormat: "YYYY",
                                    })}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    style={{
                      width: "25%",
                      borderRight: "1px solid #000",
                      paddingBottom: 5,
                      paddingRight: 20,
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ paddingLeft: 10, width: 20 }}>g.</td>
                        </tr>
                        <tr>
                          <td style={{ paddingLeft: 10, paddingBottom: 5 }}>
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td>Height</td>
                                  <td>
                                    <Field
                                      component={renderField}
                                      type="text"
                                      style={{ width: 50 }}
                                      name="Height"
                                      validate={validateRequired}
                                    />
                                    &nbsp;&nbsp;m
                                  </td>
                                </tr>
                                <tr>
                                  <td>Weight</td>
                                  <td>
                                    <Field
                                      component={renderField}
                                      type="text"
                                      style={{ width: 50 }}
                                      name="Weight"
                                      validate={validateRequired}
                                    />
                                    &nbsp;&nbsp;kg
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    style={{
                      width: "25%",
                      paddingBottom: 5,
                      paddingRight: 20,
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ paddingLeft: 10, width: 20 }}>h.</td>
                          <td>Date Employed</td>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td style={{ paddingBottom: 5 }}>
                            <table
                              style={{
                                width: "100%",
                                border: "1px solid #000",
                                borderCollapse: "collapse",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                  >
                                    Day
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                  >
                                    Month
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                  >
                                    Year
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                    id="RO_JoinDateDay"
                                  >
                                    {renderValue({
                                      fieldName: "JoinDate",
                                      fieldFormat: "date",
                                      dateFormat: "DD",
                                    })}
                                    <Field component={renderField} type="hidden" name="JoinDate" />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                    id="RO_JoinDateMonth"
                                  >
                                    {renderValue({
                                      fieldName: "JoinDate",
                                      fieldFormat: "date",
                                      dateFormat: "MMM",
                                    })}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      border: "1px solid #000",
                                    }}
                                    id="RO_JoinDateYear"
                                  >
                                    {renderValue({
                                      fieldName: "JoinDate",
                                      fieldFormat: "date",
                                      dateFormat: "YYYY",
                                    })}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            II)&nbsp;FAMILY HISTORY of the EMPLOYEE / ELIGIBLE MEMBER
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: 10, borderBottom: "1px solid #000" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td colSpan={2}>
                    Has any of your natural parents or sibling(s) died or suffered from cancer**,
                    heart disease, stroke, high blood pressure,diabetes, kidney disease, mental
                    disorder, tuberculosis or any hereditary disease(s)?
                  </td>
                </tr>
                <tr>
                  <td style={{ width: 140 }}>
                    <label htmlFor="EmpFamilyHistory_Yes">Yes</label>
                    <Field
                      component={renderField}
                      type="radio"
                      name="EmpFamilyHistory"
                      id="EmpFamilyHistory_Yes"
                      value="Yes"
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="EmpFamilyHistory_No">No</label>
                    <Field
                      component={renderField}
                      type="radio"
                      name="EmpFamilyHistory"
                      id="EmpFamilyHistory_No"
                      value="No"
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </td>
                  <td>
                    <span style={{ fontWeight: "bold" }}>
                      IF YES, PLEASE PROVIDE DETAILS BELOW (<sup>**</sup>
                      for CANCER, please specify the type of cancer)
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    If Alive
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    If Deceased
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                  >
                    Relationship
                    <br />
                    (Father, mother, sister(s) or brothers(s))
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                  >
                    Please indicate type of Medical Condition and the exact Diagnosis
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                  >
                    Age at time of Diagnosis
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                  >
                    Age at Death
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                  >
                    Cause of Death
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyRelationship1"
                      style={{ width: 240 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      multiLine
                      boxed
                      name="FamilyMedicalCondition1"
                      id="FamilyMedicalCondition1"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDiagnosis1"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDeath1"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      name="FamilyCauseOfDeath1"
                      id="FamilyCauseOfDeath1"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyRelationship2"
                      id="FamilyRelationship2"
                      style={{ width: 240 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      name="FamilyMedicalCondition2"
                      id="FamilyMedicalCondition2"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDiagnosis2"
                      id="FamilyAgeAtDiagnosis2"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDeath2"
                      id="FamilyAgeAtDeath2"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      name="FamilyCauseOfDeath2"
                      id="FamilyCauseOfDeath2"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyRelationship3"
                      id="FamilyRelationship3"
                      style={{ width: 240 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      name="FamilyMedicalCondition3"
                      id="FamilyMedicalCondition3"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDiagnosis3"
                      id="FamilyAgeAtDiagnosis3"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDeath3"
                      id="FamilyAgeAtDeath3"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      name="FamilyCauseOfDeath3"
                      id="FamilyCauseOfDeath3"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyRelationship4"
                      id="FamilyRelationship4"
                      style={{ width: 240 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      name="FamilyMedicalCondition4"
                      id="FamilyMedicalCondition4"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDiagnosis4"
                      id="FamilyAgeAtDiagnosis4"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="FamilyAgeAtDeath4"
                      id="FamilyAgeAtDeath4"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      name="FamilyCauseOfDeath4"
                      id="FamilyCauseOfDeath4"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            III)&nbsp;DEPENDANT(S) PARTICULARS - Complete this section only If you are applying for
            Group Hospital and Surgical Insurance for your dependants. If you have more than 3
            children, please furnish the Information of all your children after the 3<sup>rd</sup>{" "}
            child on a separate sheet of paper.
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                      width: 120,
                    }}
                    rowSpan={2}
                  >
                    Relationship
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                    rowSpan={2}
                  >
                    Name (According to NRIC/Passport)
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                    rowSpan={2}
                  >
                    Sex
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: 180,
                    }}
                    colSpan={3}
                  >
                    Date of Birth
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    rowSpan={2}
                  >
                    Height
                    <br />
                    (m)
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    rowSpan={2}
                  >
                    Weight
                    <br />
                    (kg)
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: 60,
                    }}
                  >
                    Day
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: 60,
                    }}
                  >
                    Month
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: 60,
                    }}
                  >
                    Year
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Spouse
                  </td>
                  <td
                    id="RO_SpouseName"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "SpouseName",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="SpouseName"
                      id="SpouseName"
                    />
                  </td>
                  <td
                    id="RO_SpouseGender"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "SpouseGender",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="SpouseGender"
                      id="SpouseGender"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SpouseBirthDateDay"
                  >
                    {renderValue({
                      fieldName: "SpouseBirthDate",
                      fieldFormat: "date",
                      dateFormat: "DD",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="SpouseBirthDate"
                      id="SpouseBirthDate"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SpouseBirthDateMonth"
                  >
                    {renderValue({
                      fieldName: "SpouseBirthDate",
                      fieldFormat: "date",
                      dateFormat: "MM",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SpouseBirthDateYear"
                  >
                    {renderValue({
                      fieldName: "SpouseBirthDate",
                      fieldFormat: "date",
                      dateFormat: "YYYY",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="SpouseHeight"
                      id="SpouseHeight"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="SpouseWeight"
                      id="SpouseWeight"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    1<sup>st</sup>
                    Child
                  </td>
                  <td
                    id="RO_FirstChildName"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "FirstChildName",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="FirstChildName"
                      id="FirstChildName"
                    />
                  </td>
                  <td
                    id="RO_FirstChildGender"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "FirstChildGender",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="FirstChildGender"
                      id="FirstChildGender"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_FirstChildBirthDateDay"
                  >
                    {renderValue({
                      fieldName: "FirstChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "DD",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="FirstChildBirthDate"
                      id="FirstChildBirthDate"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_FirstChildBirthDateMonth"
                  >
                    {renderValue({
                      fieldName: "FirstChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "MM",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_FirstChildBirthDateYear"
                  >
                    {renderValue({
                      fieldName: "FirstChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "YYYY",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="FirstChildHeight"
                      id="FirstChildHeight"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="FirstChildWeight"
                      id="FirstChildWeight"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    2<sup>nd</sup>
                    Child
                  </td>
                  <td
                    id="RO_SecondChildName"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "SecondChildGender",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="SecondChildName"
                      id="SecondChildName"
                    />
                  </td>
                  <td
                    id="RO_SecondChildGender"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "SecondChildName",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="SecondChildGender"
                      id="SecondChildGender"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SecondChildBirthDateDay"
                  >
                    {renderValue({
                      fieldName: "SecondChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "DD",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="SecondChildBirthDate"
                      id="SecondChildBirthDate"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SecondChildBirthDateMonth"
                  >
                    {renderValue({
                      fieldName: "SecondChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "MM",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_SecondChildBirthDateYear"
                  >
                    {renderValue({
                      fieldName: "SecondChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "YYYY",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="SecondChildHeight"
                      id="SecondChildHeight"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="SecondChildWeight"
                      id="SecondChildWeight"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    3<sup>rd</sup>
                    Child
                  </td>
                  <td
                    id="RO_ThirdChildName"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "ThirdChildName",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="ThirdChildName"
                      id="ThirdChildName"
                    />
                  </td>
                  <td
                    id="RO_ThirdChildGender"
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {renderValue({
                      fieldName: "ThirdChildGender",
                      fieldFormat: "text",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="ThirdChildGender"
                      id="ThirdChildGender"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_ThirdChildBirthDateDay"
                  >
                    {renderValue({
                      fieldName: "ThirdChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "DD",
                    })}
                    <Field
                      component={renderField}
                      type="hidden"
                      name="ThirdChildBirthDate"
                      id="ThirdChildBirthDate"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_ThirdChildBirthDateMonth"
                  >
                    {renderValue({
                      fieldName: "ThirdChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "MM",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id="RO_ThirdChildBirthDateYear"
                  >
                    {renderValue({
                      fieldName: "ThirdChildBirthDate",
                      fieldFormat: "date",
                      dateFormat: "YYYY",
                    })}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="ThirdChildHeight"
                      id="ThirdChildHeight"
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      style={{ width: 50 }}
                      name="ThirdChildWeight"
                      id="ThirdChildWeight"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            IV)&nbsp;HABITS of the EMPLOYEE / ELIGIBLE MEMBER (and DEPENDANT(S) IF APPLICABLE)
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    rowSpan={3}
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: "60%",
                    }}
                  >
                    <div style={{ color: "#f00" }}>
                      Please tick Yes or No.{" "}
                      <span style={{ fontWeight: "bold" }}>
                        If Yes, please provide details in the respective column(s).
                      </span>
                    </div>
                    Please note: Section IV under child(ren) column is not applicable for dependant
                    aged 12 years & below.
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                    colSpan={2}
                  >
                    Employee
                  </td>
                  <td
                    style={{
                      color: "#f00",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                    }}
                    colSpan={4}
                  >
                    Answer ONLY IF to be insured
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Spouse
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Child(ren)
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                </tr>
                <RadioButtonGroupRow
                  questionDesc="Have you ever smoked in the last 12 months? If Yes, please provide details of smoking:"
                  questionNumber={1}
                  questionId="Smoke"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                />
                <tr>
                  <td style={{ borderRight: "1px solid #000" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>a. No. of sticks you smoke per day:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="EmpSmokeQuantity"
                      id="EmpSmokeQuantity"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="SpSmokeQuantity"
                      id="SpSmokeQuantity"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="ChSmokeQuantity"
                      id="ChSmokeQuantity"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>b. No. of years since you have been smoking:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="EmpSmokeNoOfYears"
                      id="EmpSmokeNoOfYears"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="SpSmokeNoOfYears"
                      id="SpSmokeNoOfYears"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="ChSmokeNoOfYears"
                      id="ChSmokeNoOfYears"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <RadioButtonGroupRow
                  questionDesc="Do you consume beer, wine or other alcoholic beverages? If Yes, please furnish details of alcohol consumption:"
                  questionNumber={2}
                  questionId="ConsumeAlcohol"
                  options={["Yes", "No"]}
                  columns={["Emp", "SpEmp", "ChEmp"]}
                />
                <tr>
                  <td style={{ borderRight: "1px solid #000" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>a. Type of alcohol taken:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="EmpAlcoholType"
                      id="EmpAlcoholType"
                      style={{ width: 120 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="SpAlcoholType"
                      id="SpAlcoholType"
                      style={{ width: 120 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="ChAlcoholType"
                      id="ChAlcoholType"
                      style={{ width: 120 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>b. Average weekly consumption with units of measurement:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="EmpAlcoholQuantity"
                      id="EmpAlcoholQuantity"
                      style={{ width: 120 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="SpAlcoholQuantity"
                      id="SpAlcoholQuantity"
                      style={{ width: 120 }}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="ChAlcoholQuantity"
                      id="ChAlcoholQuantity"
                      style={{ width: 120 }}
                    />
                  </td>
                </tr>
                <RadioButtonGroupRow
                  questionDesc="Do you engage in or intend to engage in any sport(s) or occupation of a dangerous /
                                hazardous nature? E.g. scuba / skin diving, motor racing, military / private flying other than as a fare paying passenger,
                                parachuting, etc? If Yes, please state details on the type of sports you participate in:"
                  questionNumber={3}
                  questionId="Adventure"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                />
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={4}
                      cols={30}
                      name="EmpAdventureInfo"
                      id="EmpAdventureInfo"
                      defaultValue={""}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={4}
                      cols={30}
                      name="SpAdventureInfo"
                      id="SpAdventureInfo"
                      defaultValue={""}
                    />
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={4}
                      cols={30}
                      name="ChAdventureInfo"
                      id="ChAdventureInfo"
                      defaultValue={""}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            V)&nbsp;PARTICULARS of HEALTH of the EMPLOYEE / ELIGIBLE MEMBER (and DEPENDANT(S) IF
            APPLICABLE)
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    rowSpan={3}
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: "60%",
                    }}
                  >
                    <div style={{ color: "#f00" }}>
                      Please tick Yes or No.{" "}
                      <span style={{ fontWeight: "bold" }}>
                        If Yes, please provide details under Section VI.
                      </span>
                    </div>
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                    colSpan={2}
                  >
                    Employee
                  </td>
                  <td
                    style={{
                      color: "#f00",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                    }}
                    colSpan={4}
                  >
                    Answer ONLY IF to be insured
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Spouse
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Child(ren)
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                </tr>
                <RadioButtonGroupRow
                  questionDesc="Has any proposal for life or disability or health assurance on your life to this or any other insurance office
                              ever been declined, postponed or accepted at other than normal terms?"
                  questionNumber={1}
                  questionId="Exclusions"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionDesc="Are you now receiving or considering to receive medical treatment from a doctor or intending to consult any doctor for any reason?"
                  questionNumber={2}
                  questionId="MedTreatment"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionDesc="Have you ever undergone any health screening or had any medical investigations carried out, whether on your own accord or on the recommendation of a doctor,
                                such as X-ray, ultrasound, electrocardiogram (ECG), barium meal examination, CT scan, biopsy, blood or urine test, etc., in the past 5 years?"
                  questionNumber={3}
                  questionId="DiagnosisInfo"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionDesc="Have you been advised to undergo any diagnostic test or surgical operation that has not yet been performed?"
                  questionNumber={4}
                  questionId="PendingMedTreatment"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionDesc="Have you ever taken addictive drugs, narcotics, glue sniffing or been treated for drug addiction?"
                  questionNumber={5}
                  questionId="DrugAddiction"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionDesc="Have you ever had or been treated for alcoholism?"
                  questionNumber={6}
                  questionId="Alcoholism"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <tr>
                  <td style={{ borderRight: "1px solid #000", padding: 5 }}>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>7</td>
                          <td>Have you ever had or been told to have or been treated for:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td style={{ textAlign: "center" }} />
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                  <td style={{ textAlign: "center" }} />
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                  <td style={{ textAlign: "center" }} />
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                </tr>
                <RadioButtonGroupRow
                  questionDesc="a. Diabetes, thyroid disorders, or any other endocrine disorders?"
                  questionId="EndocrineDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="b. Asthma, persistent cough, coughing with blood, pneumonia, tuberculosis, bronchitis, chest or breathing complaints or discomfort, and I or any other lung disorders?"
                  questionId="LungDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="c. Raised cholesterol, high blood pressure, heart attack, rheumatic fever, Kawasaki disease, heart murmur, palpitation, coronary artery disease,
                                mitral valve prolapse, or other heart valve disorders, breathlessness, irregular or fast heart rate, chest discomfort or chest pain, and/or any disease
                                or disorders of the heart or blood vessels?"
                  questionId="HeartDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="d. Epilepsy, fits, stroke, paralysis, dementia, Parkinson's disease, multiple sclerosis, motor neurone disease,
                                weakness of limbs, polio, fainting spells, prolonged headache, unconsciousness, nervous breakdown, depression, or any other nervous or
                                mental disorders, or disease of the brain?"
                  questionId="MentalDisorders"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="e. Gastritis, stomach or duodenal ulcer, blood in the stools, fistula, hernia, haemorrhoids or piles, irritable bowel syndrome, or any other stomach or bowel disorders?"
                  questionId="BowelDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="f. Jaundice, hepatitis B carrier or any form of hepatitis, liver disorder or gall bladder disorder?"
                  questionId="GallbladderDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="g. Albumin or protein in urine, blood or sugar in urine, kidney stones, infection or any other disorders of the kidney, bladder, urinary or genital organs?"
                  questionId="KidneyDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="h. Slipped disc, gout, any form of arthritis, joint pain or deformity, and/or disorders of the muscles, spine, limbs or joints or severe injury?"
                  questionId="PhysicalInjury"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="i. Anaemia, any other disorders of the blood, advised to abstain from donating blood,
                                or received blood transfusion or blood products on account of haemophilia or any other reason?"
                  questionId="BloodDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="j. Ear discharge, nose bleeds, double vision, or visual impairment or impaired hearing or speech, or any other disorders of the ear, nose, or throat?"
                  questionId="HearingAndSight"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="k. cancer, tumours, cysts or growths of any kind?"
                  questionId="Cancer"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="l. Congenital anomalies, physical disability or any unusual skin lesions, or any other illness, disorder, operation, hospital admission,
                                accident or injury not mentioned above?"
                  questionId="PhysicalDisability"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionNumber={8}
                  questionDesc="Have you or your spouse been told to have, or received any medical advice or counselling or treatment in connection with sexually transmitted disease,
                                AIDS, or AIDS Related Complex or any other AIDS related condition?"
                  questionId="SexualDisease"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionNumber={9}
                  questionDesc="a. Have you ever had HIV testing done? (If Yes, please state reason and result under Section VI.)"
                  questionId="HIVTesting"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="b. Have you ever in the last 3 months had any of the following symptoms for more than
                                one week continuously: fatigue, weight loss, diarrhoea, enlarged nodes or unusual skin lesions?"
                  questionId="WeightLoss"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <RadioButtonGroupRow
                  questionNumber={10}
                  questionDesc="Do you have a regular attending doctor? If Yes, please state the name of the doctor "
                  questionId="RegularDoc"
                  questionInput={{
                    type: "text",
                    name: "RegularDoctorName",
                  }}
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="and the address of clinic "
                  questionId=""
                  questionInput={{
                    type: "textarea",
                    name: "RegularClinicAddress",
                    rows: "3",
                    cols: "40",
                  }}
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{ borderBottom: "1px solid #000" }}
                />
                <tr>
                  <td style={{ borderRight: "1px solid #000", padding: 5 }}>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>11</td>
                          <td>
                            <strong>
                              FOR FEMALE ONLY (Also to be completed for child(ren) aged 12 years &
                              above)
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td style={{ textAlign: "center" }} />
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                  <td style={{ textAlign: "center" }} />
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                  <td style={{ textAlign: "center" }} />
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                </tr>
                <RadioButtonGroupRow
                  questionDesc="a. Have you ever been found to have or are you aware of any breast lumps or any other disease or disorders of the breast?"
                  questionId="BreastDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="b. Have you ever suffered from irregular or painful or unusually heavy menstruation, fibroids, cysts or any other disorders of the female organs?"
                  questionId="MenstruationDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="c. Have you ever had any abnormal pap smear test or been told by any doctor to have a repeat pap smear within the next six months?"
                  questionId="PapSmearDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="d. Have you been advised to have a mammogram, biopsy, operation of the breasts, ultrasound of the pelvis or any other gynaecological investigations?"
                  questionId="GynaecologicalDisorder"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <RadioButtonGroupRow
                  questionDesc="e. Are you pregnant now?"
                  questionId="Pregnant"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
                <tr>
                  <td style={{ borderRight: "1px solid #000", padding: 5 }}>
                    If Yes, please state the weeks/months of pregnancy.
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Field
                      component={renderField}
                      type="text"
                      name="EmpPregnantDurationValue"
                      id="EmpPregnantDurationValue"
                      style={{ width: 40 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component="select"
                      name="EmpPregnantDurationUnit"
                      id="EmpPregnantDurationUnit"
                    >
                      <option value="Weeks">Weeks</option>
                      <option value="Months">Months</option>
                    </Field>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Field
                      component={renderField}
                      type="text"
                      name="SpPregnantDurationValue"
                      id="SpPregnantDurationValue"
                      style={{ width: 40 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component="select"
                      name="SpPregnantDurationUnit"
                      id="SpPregnantDurationUnit"
                    >
                      <option value="Weeks">Weeks</option>
                      <option value="Months">Months</option>
                    </Field>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Field
                      component={renderField}
                      type="text"
                      name="ChPregnantDurationValue"
                      id="ChPregnantDurationValue"
                      style={{ width: 40 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <Field
                      component="select"
                      name="ChPregnantDurationUnit"
                      id="ChPregnantDurationUnit"
                    >
                      <option value="Weeks">Weeks</option>
                      <option value="Months">Months</option>
                    </Field>
                  </td>
                </tr>
                <RadioButtonGroupRow
                  questionDesc="f. Were there any complications during any of your pregnancy(ies) such as gestational diabetes, hypertension, etc?"
                  questionId="PregnantComplication"
                  options={["Yes", "No"]}
                  columns={["Emp", "Sp", "Ch"]}
                  style={{}}
                />
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            VI)&nbsp;If the answer to any of the questions In Section V Is Yes, please provide with
            FULL DETAILS here.
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                      width: 100,
                    }}
                    rowSpan={2}
                  >
                    Question Number
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                    rowSpan={2}
                  >
                    Name of Person Concerned (Employee/Spouse/Child(ren))
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                    rowSpan={2}
                  >
                    {[
                      'Details of Diagnostic Test with reason & result / Doctor"s ',
                      "Diagnosis / lnjury / Treatment",
                    ].join("")}
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      textAlign: "center",
                      border: "1px solid #000",
                    }}
                  >
                    Duration of Illness
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      border: "1px solid #000",
                    }}
                    rowSpan={2}
                  >
                    Name of Doctor Consulted & Address of Clinic
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    From
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    To
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoSubQNo1"
                      id="MoreInfoSubQNo1"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoName1"
                      id="MoreInfoName1"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoDiagnosis1"
                      id="MoreInfoDiagnosis1"
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoFrom1"
                      id="MoreInfoFrom1"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoTo1"
                      id="MoreInfoTo1"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoMedicalProvider1"
                      id="MoreInfoMedicalProvider1"
                      defaultValue={""}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoSubQNo2"
                      id="MoreInfoSubQNo2"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoName2"
                      id="MoreInfoName2"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoDiagnosis2"
                      id="MoreInfoDiagnosis2"
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoFrom2"
                      id="MoreInfoFrom2"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoTo2"
                      id="MoreInfoTo2"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoMedicalProvider2"
                      id="MoreInfoMedicalProvider2"
                      defaultValue={""}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoSubQNo3"
                      id="MoreInfoSubQNo3"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoName3"
                      id="MoreInfoName3"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoDiagnosis3"
                      id="MoreInfoDiagnosis3"
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoFrom3"
                      id="MoreInfoFrom3"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoTo3"
                      id="MoreInfoTo3"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoMedicalProvider3"
                      id="MoreInfoMedicalProvider3"
                      defaultValue={""}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoSubQNo4"
                      id="MoreInfoSubQNo4"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoName4"
                      id="MoreInfoName4"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoDiagnosis4"
                      id="MoreInfoDiagnosis4"
                      defaultValue={""}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoFrom4"
                      id="MoreInfoFrom4"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component={renderField}
                      type="text"
                      name="MoreInfoTo4"
                      id="MoreInfoTo4"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    <Field
                      component="textarea"
                      rows={3}
                      cols={40}
                      name="MoreInfoMedicalProvider4"
                      id="MoreInfoMedicalProvider4"
                      defaultValue={""}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div>
      <span style={{ fontWeight: "bold" }}>DECLARATION: </span>I hereby declare that, to the best of
      my knowledge and belief the statements and answers given in this health declaration are true,
      complete and that I have not withheld any material facts, that is, facts likely to influence
      the assessment and acceptance of this application. I understand that any misstatement of fact,
      whether by commission or omission may be grounds for the Company in its absolute and sole
      discretion to decline to pay any benefit which may otherwise have been payable. I agree that
      this application, together with any additional statements signed by me which shall be deemed
      to be part of this declaration, shall be the basis of the contract of the insurance.
      <br />
      <br />
      {[
        "I understand that my application will be subject to acceptance by the ",
        "Company, and that I and/or my Dependant(s) will not be insured under any ",
        'of the insurance plan(s) for which my or my Dependant(s)"s application is ',
        "subject to acceptance until the Company advises the Policyholder the terms ",
        "and conditions on accepting insurance on myself and/or my Dependant(s), ",
        "and that the Company reserves the right to decline insurance or impose ",
        "special terms and conditions.",
      ].join("")}
      <br />
      <br />I understand that:
      <br />
      <table>
        <tbody>
          <tr>
            <td>(a)</td>
            <td>
              {[
                'if my application for my and/or my Dependant(s)" insurance under ',
                'any of the above plan(s) is accepted, my and/or Dependant(s)" ',
                "insurance under the plan shall terminate if the Policyholder does ",
                "not renew the plan before the expiry of any period of insurance, ",
                "or cancel the plan, or if I and/or my Dependant(s) attain the age ",
                'at which I and/or my Dependant(s)" insurance terminates as ',
                "specified in the terms and conditions of the insurance plan, and",
              ].join("")}
            </td>
          </tr>
          <tr>
            <td>(b)</td>
            <td>
              these plan(s) are yearly renewable and that the terms and conditions of the insurance
              plan(s) I and/or my Dependant(s) are insured under, including the premiums payable, at
              any renewal of the plan(s), may change upon agreement between the Policyholder and the
              Company.
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <span style={{ color: "#f00" }}>
        <span style={{ fontWeight: "bold" }}>AUTHORISATION: I, </span>
        {[
          "the undersigned, authorise any medical source, insurance ",
          'office/organisation or the Life Insurance Association"s medical registry ',
          "to release any medical record or knowledge about me and/or my ",
          "Dependant(s) to the Company for risk assessment of my Group Insurance ",
          "Application.",
        ].join("")}
        <br />
        {[
          "I further consent to, and agree to procure my Dependant(s) to agree and ",
          "consent, the Company in releasing any information declared in my and/or ",
          'my dependant(s)" Personal Health Declaration Form I Personal Statement ',
          'and/or information revealed in my and/or my Dependant(s)" ',
          "questionnaires, medical reports and laboratory reports to my employer or ",
          "the administrator and/or the appointed insurance intermediary servicing ",
          "this Group Insurance Policy. A photocopy of this authorisation shall be ",
          "as effective and valid as the original.",
        ].join("")}
      </span>
      <br />
      <br />
      <span style={{ fontWeight: "bold" }}>PERSONAL DATA: </span>
      {[
        "By providing the information set out above, I agree and consent, and agree ",
        'to procure my dependant(s) to agree and consent, to the "Company", its ',
        'related corporations (collectively, the "Companies"), as well as their ',
        'respective representatives and agents ("Representatives") collecting, ',
        'using, disclosing and sharing amongst themselves my or my Dependant(s)"s ',
        'personal data, and disclosing such personal data to the Companies" ',
        "authorised service providers and relevant third parties for purposes ",
        "reasonably required by the Companies to evaluate my proposal and to ",
        "provide the relevant products or services which I am applying or have ",
        "applied for (including, without limitation, any policy renewals and policy ",
        "upgrades, substitutions or replacements).",
      ].join("")}
      <br />
      <br />
      {[
        'These purposes are set out in Great Eastern"s Privacy Statement, which is ',
        "accessible at http://www.greateasternlife.com/sg/en/pncpolicies.htm and ",
        "which I confirm I have read and understood.",
      ].join("")}
    </div>
    <br />
    <br />
    <CheckboxField validate={validateRequired} name="declaration" id="declaration">
      <strong>I have read and accept this declaration</strong>
    </CheckboxField>
    <br />
    <br />
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td style={{ fontWeight: "bold", width: 50 }}>Date: </td>
          <td style={{ borderBottom: "1px solid #000", width: 280 }} id="RO_CompletedOn" />
          <td>&nbsp;</td>
          <td style={{ textAlign: "left", borderBottom: "1px solid #000" }} id="RO_CompletedBy" />
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>
            <div style={{ fontWeight: "bold" }}>Day/Month/Year</div>
            (Current Date of Completion of this form)
          </td>
          <td>&nbsp;</td>
          <td style={{ width: 320 }}>
            <div style={{ fontWeight: "bold" }}>Signature of Employee/ Eligible Member</div>
            (If this is an application for Dependant(s), <br />
            the Employee will sign on behalf of the Dependant(s))
          </td>
        </tr>
        <tr>
          <td colSpan={3} style={{ paddingTop: 30 }}>
            &nbsp;
          </td>
          <td
            style={{
              textAlign: "left",
              borderBottom: "1px solid #000",
              paddingTop: 30,
            }}
            id="RO_CompletedByName"
          />
        </tr>
        <tr>
          <td colSpan={3}>&nbsp;</td>
          <td style={{ fontWeight: "bold" }}>Name of the Employee/Eligible Member</td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td>
            <span style={{ fontWeight: "bold" }}>
              The Great Eastern Life Assurance Company Limited
            </span>{" "}
            (Reg. No. 1908 00011G)
            <br />
            Mailing Address: 1 Pickering Street, #10-01 Great Eastern Centre Singapore 048659
            <br />
            Tel +65 6248 0000&nbsp;&nbsp;&nbsp;&nbsp;Fax +65 6532
            3478&nbsp;&nbsp;&nbsp;&nbsp;Website www.greateasternlife.com
          </td>
          <td style={{ textAlign: "right", textDecoration: "underline" }}>
            GID/UWG/PHD/COM/200501
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Ge/GEHD201412.js